import initialState from "./banquetInquiry.state.js";
import actions from "./banquetInquiry.actions.js";
import mutations from "./banquetInquiry.mutations.js";
import getters from "./banquetInquiry.getters.js";

export default {
  state: initialState,
  actions,
  mutations,
  getters
};
